// Automatically sets readable text color based on a button's background luminance.
// Applies to any element with [data-auto-contrast].
(function () {
  function relativeLuminance(r, g, b) {
    var a = [r, g, b].map(function (v) {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
  }

  function parseColor(str) {
    var m = str.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    if (!m) return null;
    return [parseInt(m[1], 10), parseInt(m[2], 10), parseInt(m[3], 10)];
  }

  function applyContrast(el) {
    var bg = getComputedStyle(el).backgroundColor;
    var rgb = parseColor(bg);
    if (!rgb) return;
    var luminance = relativeLuminance(rgb[0], rgb[1], rgb[2]);
    el.style.color = luminance > 0.45 ? '#201410' : '#EDE0D0';
  }

  function run() {
    document.querySelectorAll('[data-auto-contrast]').forEach(applyContrast);
  }

  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:select', run);
})();
